"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("BasisModal", {
    attrs: {
      size: "lg",
      title: _vm.operate === "edit" ? "编辑科目" : "添加科目"
    },
    on: {
      ok: _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-tabs", {
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, _vm._l(_vm.validTabs, function (item) {
    return _c("a-tab-pane", {
      key: item.type,
      attrs: {
        tab: item.name
      }
    }, [_c("Keep-alive", [_c(item.type === _vm.activeKey ? item.component : false, {
      ref: "componentRef",
      refInFor: true,
      tag: "component",
      staticStyle: {
        "min-height": "60vh"
      },
      attrs: {
        operate: _vm.operate,
        record: _vm.curRecord,
        selectable: true,
        type: item.type,
        params: {
          dimension: _vm.dimension
        }
      },
      on: {
        change: _vm.handleChange
      }
    })], 1)], 1);
  }), 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;